import React, { memo, useMemo } from "react"
import { AspectRatio, Box, Button, Flex, Image } from "@chakra-ui/react"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore, { Navigation, Pagination } from "swiper"
import "swiper/css"

import type { ProductCombinedProps } from "@root/types/global"
import { Icon } from "@app/components/Icon"
import { useImage } from "@app/hooks/useImage"

type Props = {
  product: ProductCombinedProps
  borderless?: boolean
}

// eslint-disable-next-line react-hooks/rules-of-hooks
SwiperCore.use([Pagination, Navigation])

export const ProductMediaSwiperDesktop: React.FC<Props> = memo(({ product, borderless = false }) => {
  const { sortGenderImages } = useImage()
  const images = useMemo(() => product?.images.sort(sortGenderImages) || [], [product, sortGenderImages])

  return images.length > 0 ? (
    <AspectRatio bg="grey.cloud" ratio={375 / 527} w="full">
      <Box
        sx={{
          ".swiper-horizontal": { w: "full" },
          ".swiper-pagination-fraction": { color: "black" },
        }}
      >
        {images.length > 1 && (
          <>
            <Button
              id={`product-${product?.handle}-navigation-prev`}
              position="absolute"
              variant="pdpImageCarousel"
              left={4}
              h={12}
              w={12}
              border={borderless ? "none" : "initial"}
            >
              <Icon name="arrow-left" fill="transparent" h={6} w={6} />
            </Button>
            <Button
              id={`product-${product?.handle}-navigation-next`}
              position="absolute"
              variant="pdpImageCarousel"
              right={4}
              h={12}
              w={12}
              border={borderless ? "none" : "initial"}
            >
              <Icon name="arrow-right" fill="transparent" h={6} w={6} />
            </Button>
          </>
        )}
        <Swiper
          cssMode
          pagination={images.length > 1 ? { clickable: true, el: `#product-${product?.handle}-paginationDesktop`, type: "fraction" } : {}}
          navigation={{ prevEl: `#product-${product?.handle}-navigation-prev`, nextEl: `#product-${product?.handle}-navigation-next` }}
          slidesPerView={1}
          spaceBetween={0}
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <Box>
                <Image {...image} w="full" />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
        <Flex
          justify="center"
          pos="absolute"
          insetX={0}
          id={`product-${product?.handle}-paginationDesktop`}
          zIndex={10}
          fontSize="md"
          gap={2}
          pb={6}
        />
      </Box>
    </AspectRatio>
  ) : (
    <AspectRatio bg="grey.cloud" ratio={375 / 527} w="full">
      <Box />
    </AspectRatio>
  )
})
